import { render, staticRenderFns } from "./CommercialFreestandingOfficeProperty.vue?vue&type=template&id=232d32c2&scoped=true&"
import script from "./CommercialFreestandingOfficeProperty.vue?vue&type=script&lang=ts&"
export * from "./CommercialFreestandingOfficeProperty.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialFreestandingOfficeProperty.vue?vue&type=style&index=0&id=232d32c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d32c2",
  null
  
)

export default component.exports